import React from 'react';

class ChartCustomTooltip extends React.Component {
  render() {
    const {text, unit, payload} = this.props;

    const data = Array.isArray(payload)
      ? payload[0]
      : undefined
    const value = data && data.payload
      ? data.payload.Value
      : '--'
    const time = data
      ? data.payload.Time.toLocaleString()
      : '--'
    return (<div className="chart-tooltip">
      <div>
        <span className="meta">{text}:
        </span>
        <span className="total">{value}</span>
        <span className="unit">{unit}
        </span>
      </div>
      <div className="time">lúc: {time}</div>
    </div>);
  }
};

export default ChartCustomTooltip;



// WEBPACK FOOTER //
// ./src/components/ChartCustomTooltip.js